// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"_2aG2xxtq2y8lRWivC14X5P","paginationPageNumber":"_3myVF6pXZACP4zb9473jXN","paginationPageNumberActive":"_1ATZ-GHSrasFKRx4his2c_"};